import { lazy } from "react";
import { addHandleRoute, createRoute } from "../utils/RouteHelper";

// route
export const salesRoute = createRoute({
    path: "/sales",
    name: "menu.sales",
    icon: "point_of_sale",
    accCode: "penjualan",
    exclude_breadcrumbs: true,
});

export const sQuotationRoute = createRoute({
    path: `${salesRoute.path}/quotation`,
    name: "sales_quotation.",
    code: 'QP',
    accCode: "penjualan_penawaran",
    parentCode: salesRoute.accCode,
});

export const sQuoCreateRoute = createRoute({
    path: `${sQuotationRoute.path}/create`,
    name: "sales_quotation.add",
    code: 'QP',
    accCode: "penjualan_penawaran",
    parentCode: salesRoute.accCode,
    action: "create",
    redirectTo: sQuotationRoute.path,
});

export const sQuoViewRoute = createRoute({
    path: `${sQuotationRoute.path}/view`,
    name: "sales_quotation.detail",
    code: 'QP',
    accCode: "penjualan_penawaran",
    parentCode: salesRoute.accCode,
});

export const sQuoProcessRoute = createRoute({
    path: `${sQuotationRoute.path}/process`,
    name: "sales_quotation.process",
    code: 'QP',
    accCode: "penjualan_penawaran",
    parentCode: salesRoute.accCode,
});

export const sSORoute = createRoute({
    path: `${salesRoute.path}/so`,
    name: "sales_so.",
    code: 'SO',
    accCode: "penjualan_sales_order",
    parentCode: salesRoute.accCode,
});

export const sSOViewRoute = createRoute({
    path: `${sSORoute.path}/view`,
    name: "sales_so.detail",
    code: 'SO',
    accCode: "penjualan_sales_order",
    parentCode: salesRoute.accCode,
});

export const sSOCreateRoute = createRoute({
    path: `${sSORoute.path}/create`,
    name: "sales_so.add",
    code: 'SO',
    accCode: "penjualan_sales_order",
    parentCode: salesRoute.accCode,
    action: "create",
    redirectTo: sSORoute.path,
});

export const sSOUpdateRoute = createRoute({
    path: `${sSORoute.path}/edit`,
    name: "sales_so.edit",
    code: 'SO',
    accCode: "penjualan_sales_order",
    parentCode: salesRoute.accCode,
    action: "edit",
    redirectTo: sSORoute.path,
});

export const sDOOutCreateRoute = createRoute({
    path: `${sSORoute.path}/do/create`,
    name: "sales_so.do",
    code: 'SO',
    accCode: "penjualan_sales_order",
    parentCode: salesRoute.accCode,
    action: "create",
    redirectTo: sSORoute.path,
});

export const sPORoute = createRoute({
    path: `${salesRoute.path}/po`,
    name: "sales_so.po",
    code: 'SO',
    accCode: "",
    parentCode: salesRoute.accCode,
});

export const sPOViewRoute = createRoute({
    path: `${sPORoute.path}/view`,
    name: "sales_so.po_detail",
    code: 'SO',
    accCode: "",
    parentCode: salesRoute.accCode,
});

export const sRefItemOutRoute = createRoute({
    path: `${salesRoute.path}/do`,
    name: "Delivery Order",
    code: 'DOOUT',
    accCode: "penjualan_delivery_order",
    parentCode: salesRoute.accCode,
});

export const sRefItemOutViewRoute = createRoute({
    path: `${sRefItemOutRoute.path}/view`,
    name: "Detail Delivery Order",
    code: 'DOOUT',
    accCode: "penjualan_delivery_order",
    parentCode: salesRoute.accCode,
});

export const sInvoiceRoute = createRoute({
    path: `${salesRoute.path}/invoice`,
    name: "sales_invoice.",
    code: 'INVS',
    accCode: "penjualan_tagihan_penjualan",
    parentCode: salesRoute.accCode,
});

export const sInvoiceCreateRoute = createRoute({
    path: `${sInvoiceRoute.path}/create`,
    name: "sales_invoice.add",
    code: 'INVS',
    accCode: "penjualan_tagihan_penjualan",
    parentCode: salesRoute.accCode,
    action: "create",
    redirectTo: sInvoiceRoute.path,
});

export const sInvoiceUpdateRoute = createRoute({
    path: `${sInvoiceRoute.path}/edit`,
    name: "sales_invoice.edit",
    code: 'INVS',
    accCode: "penjualan_tagihan_penjualan",
    parentCode: salesRoute.accCode,
    action: "edit",
    redirectTo: sInvoiceRoute.path,
});

export const sInvoiceViewRoute = createRoute({
    path: `${sInvoiceRoute.path}/view`,
    name: "sales_invoice.detail",
    code: 'INVS',
    accCode: "penjualan_tagihan_penjualan",
    parentCode: salesRoute.accCode,
});

export const sReturnCusRoute = createRoute({
    path: `${salesRoute.path}/returnCustomer`,
    name: "sales_returncustomer.",
    code: 'RCP',
    accCode: "",
    parentCode: salesRoute.accCode,
});

export const sPriceStockRoute = createRoute({
    path: `${salesRoute.path}/price-stock`,
    name: "sales_priceStock.",
    code: 'PriSto',
    accCode: "penjualan_daftar_harga_stock",
    parentCode: salesRoute.accCode,
});

export const sInvRecapRoute = createRoute({
    path: `${salesRoute.path}/recap`,
    name: "sales_recap.",
    code: 'RINV',
    accCode: "",
    parentCode: salesRoute.accCode,
});

export const sInvRecapCreateRoute = createRoute({
    path: `${sInvRecapRoute.path}/create`,
    name: "sales_recap.add",
    code: 'RINV',
    accCode: "",
    parentCode: salesRoute.accCode,
    action: "create",
    redirectTo: sInvRecapRoute.path,
});

export const sInvRecapViewRoute = createRoute({
    path: `${sInvRecapRoute.path}/view`,
    name: "sales_recap.detail",
    code: 'RINV',
    accCode: "",
    parentCode: salesRoute.accCode,
});

// component
const Sales = lazy(() => import("../page/sales/Sales"));
const SalesSO = lazy(() => import("../page/sales/so/SalesSO"));
const SalesSOView = lazy(() => import("../page/sales/so/view/SOView"));
const SalesSOForm = lazy(() => import("../page/sales/so/form/SalesSOForm"));
const SalesDOOutForm = lazy(() => import("../page/sales/so/form_do_out/DOOutForm"));

const SalesPO = lazy(() => import("../page/sales/po/SalesPO"));
const SalesPOView = lazy(() => import("../page/sales/po/view/SalesPOView"));

const SalesRefItemOut = lazy(() => import("../page/sales/ref_item_out/SalesRefItemOut"));
const SalesRefItemOutView = lazy(() => import("../page/sales/ref_item_out/view/SalesRefItemOutView"));

const SalesQuotation = lazy(() => import("../page/sales/quotation/SalesQuotation"));
const SalesQuotationForm = lazy(() => import("../page/sales/quotation/form/SalesQuotationForm"));
const SalesQuotationProcessForm = lazy(() => import("../page/sales/quotation_mitra/form_process/SalesQuotationProcessForm"));
const SalesQuotationMain = lazy(() => import("../page/sales/SalesQuotationMain"));

const SalesInvoice = lazy(() => import("../page/sales/invoice/SalesInvoice"));
const SalesInvoiceForm = lazy(() => import("../page/sales/invoice/form/SalesInvoiceForm"));
const SalesInvoiceView = lazy(() => import("../page/sales/invoice/view/SalesInvoiceView"));

const SalesReturCus = lazy(() => import("../page/sales/return_customer/SalesReturnCustomer"));
const SalesPriceStock = lazy(() => import("../page/sales/price_stock_list/SalesPriceStockList"));

const SalesRecapInv = lazy(() => import("../page/sales/recap/SalesInvRecap"));
const SalesRecapInvForm = lazy(() => import("../page/sales/recap/form/SalesInvRecapForm"));
const SalesRecapInvView = lazy(() => import("../page/sales/recap/view/SalesInvRecapView"));

export const salesMainTabRoutes = [
    sQuotationRoute, sSORoute,
    sRefItemOutRoute, sInvoiceRoute, sReturnCusRoute,
    sInvRecapRoute, sPriceStockRoute
];

export const salesMutationRoutes = [
    sQuoCreateRoute, sQuoViewRoute, sQuoProcessRoute,
    sSOCreateRoute, sSOUpdateRoute, sSOViewRoute, sDOOutCreateRoute,
    sPORoute, sPOViewRoute,
    sRefItemOutViewRoute,
    sInvoiceCreateRoute, sInvoiceUpdateRoute, sInvoiceViewRoute,
    sInvRecapCreateRoute, sInvRecapViewRoute
];

export const salesRoutes = {
    element: <Sales />,
    children: addHandleRoute([
        { ...sQuotationRoute, element: <SalesQuotation /> },
        { ...sQuoCreateRoute, element: <SalesQuotationForm /> },
        { ...sQuoViewRoute, element: <SalesQuotationMain type="view" /> },
        { ...sQuoProcessRoute, element: <SalesQuotationProcessForm /> },
        { ...sPORoute, element: <SalesPO /> },
        { ...sPOViewRoute, element: <SalesPOView /> },
        { ...sSORoute, element: <SalesSO /> },
        { ...sSOCreateRoute, element: <SalesSOForm /> },
        { ...sSOUpdateRoute, element: <SalesSOForm /> },
        { ...sSOViewRoute, element: <SalesSOView /> },
        { ...sDOOutCreateRoute, element: <SalesDOOutForm /> },
        { ...sRefItemOutRoute, element: <SalesRefItemOut /> },
        { ...sRefItemOutViewRoute, element: <SalesRefItemOutView /> },
        { ...sInvoiceRoute, element: <SalesInvoice /> },
        { ...sInvoiceCreateRoute, element: <SalesInvoiceForm /> },
        { ...sInvoiceUpdateRoute, element: <SalesInvoiceForm /> },
        { ...sInvoiceViewRoute, element: <SalesInvoiceView /> },
        { ...sReturnCusRoute, element: <SalesReturCus /> },
        { ...sInvRecapRoute, element: <SalesRecapInv /> },
        { ...sInvRecapCreateRoute, element: <SalesRecapInvForm /> },
        { ...sInvRecapViewRoute, element: <SalesRecapInvView /> },
        { ...sPriceStockRoute, element: <SalesPriceStock /> },
    ]),
};